import { PageKeys } from '.';

export const URLS: Record<PageKeys, string> = {
  home: '/',
  companies: '/companies',
  companiesAll: '/companies/all',
  companiesVerified: '/companies/verified',
  companiesCompletedSetup: '/companies/completed-setup',
  companiesOngoing: '/companies/ongoing',
  companiesAddCompany: '/companies/add-company',
  login: '/login',
  company: '/company/:id',
  job: '/job/:id',
  jobs: '/jobs',
  jobsAll: '/jobs/all',
  jobsApplied: '/jobs/applied',
  jobsOngoing: '/jobs/ongoing',
  jobsSatNote: '/jobs/sat-note',
  jobsSatNoteSigned: '/jobs/sat-note-signed',
  jobsSatNoteDelayed: '/jobs/sat-note-delayed',
  jobsSatNoteLenderReview: '/jobs/sat-note-lender-review',
  jobsPayoutPending: '/jobs/payout-pending',
  jobsPaid: '/jobs/paid',
  payments: '/payments',
  paymentsAll: '/payments/all',
  paymentsCash: '/payments/cash',
  paymentsCard: '/payments/card',
  paymentsLoan: '/payments/loan',
  loans: '/loans',
  loansAll: '/loans/all',
  loansOngoing: '/loans/ongoing',
  loansFinished: '/loans/finished',
  partner: '/partner/:id',
  partners: '/partners',
  partnersFilter: '/partners/:id',
  lead: '/lead/:id',
  leads: '/leads',
  leadsPipline: '/leads/pipeline',
  leadsOpen: '/leads/open',
  leadsIssued: '/leads/issued',
  leadsCreditDeclined: '/leads/credit-declined',
  leadsQuoteDeclined: '/leads/quote-declined',
  leadsTradeAccepted: '/leads/trade-accepted',
  leadsTradeDeclined: '/leads/trade-declined',
  leadsTradeNotified: '/leads/trade-notified',
  leadsExpired: '/leads/expired',
  leadsClosed: '/leads/closed',
  payment: '/payment/:id',
  users: '/users',
  rateRequests: '/rate-requests',
  logout: '/logout',
};

export const COLOUR_INDEX = [
  'red',
  'orange',
  'green',
  'blue',
  'pink',
  'purple',
  'red-solid',
  'orange-solid',
  'green-solid',
  'blue-solid',
  'pink-solid',
  'purple-solid',
];
